import './PromoCarousel.css'
import React, {createRef, useEffect, useRef, useState} from "react";
import {IPromoSectionData, ISection} from "../../model/B2CInfo";
import AnimatedLine from "../../common/AnimatedLine";

interface IPromoCarouselProps {
    section: ISection
}

export default function PromoCarousel(props: IPromoCarouselProps) {
    const sectionData = (props.section.data as IPromoSectionData);

    const [scrollStarted, setScrollStarted] = useState(false)

    const [translateXStart, setTranslateXStart] = useState(0)
    const [translateYStart, setTranslateYStart] = useState(0)

    const [scrollStart, setScrollStart] = useState(0)
    const [scrollLeft, setScrollLeft] = useState(0)

    const [index, setIndex] = useState(4)

    const inputEl = useRef<HTMLDivElement>(null);

    useEffect(() => {
        let width = inputEl.current!.clientWidth
        let initialOffset = (inputEl.current!.scrollWidth - width) / 2
        inputEl!.current!.scroll({left: initialOffset, top: 0, behavior: "auto"})
    }, []);

    let itemWidth = 223 * (window.innerWidth / 375)
    let height = itemWidth * 455/223

    let indices = [0, 1, 2, 3, 4, 5, 6, 7, 8]
    let items = indices.map((i) => {
        let scale = 0.75;
        let translate = (1 - 0.75) / 2;
        if (inputEl.current != null) {
            let width = inputEl.current!.clientWidth
            let initialOffset = (inputEl.current!.scrollWidth - width) / 2
            let center = initialOffset + ((i - 4) * itemWidth + (i - 4) * 10)
            scale = 1 - 0.25 * Math.abs(center - scrollLeft) / (itemWidth + 10)
            translate = (1 - scale) / 2
        }
        return <div key={`${i}`} className="Promo_carousel_item" style={{minWidth: `${itemWidth}px`}}>
            <img src={sectionData.features[Math.max(0, i-1) % 3].icon} style={{
                width: "100%",
                height: "100%",
                transform: `scale(${scale}) translate(${translate}%)`
            }}/>
        </div>;
    })

    useEffect(() => {
        function preventTouch(e: any) {
            if (scrollStarted) {
                e.preventDefault();
            }
        }
        window.addEventListener('touchmove', preventTouch, {passive: false});
        return () => {
            window.removeEventListener('touchmove', preventTouch);
        }
    }, [scrollStarted])

    function snap() {
        let newIndex = index
        if (inputEl.current!.scrollLeft > scrollStart) {
            newIndex += 1;
        } else {
            newIndex -= 1;
        }
        snapToIndex(newIndex)
    }

    function snapToIndex(newIndex: number) {
        let width = inputEl.current!.clientWidth
        let initialOffset = (inputEl.current!.scrollWidth - width) / 2

        let newOffset = initialOffset + ((newIndex - 4) * itemWidth + (newIndex - 4) * 10)
        if (newIndex === 7 || newIndex === 1) {
            newIndex = 4
            setIndex(newIndex)
            inputEl!.current!.scroll({
                left: initialOffset - (newOffset - inputEl.current!.scrollLeft),
                top: 0,
                behavior: "auto"
            })
            inputEl!.current!.scroll({left: initialOffset, top: 0, behavior: "smooth"})
        } else {
            setIndex(newIndex)
            inputEl!.current!.scroll({left: newOffset, top: 0, behavior: "smooth"})
        }
    }

    return <div className="Promo_carousel_items_container">
        <div className="Promo_carousel_container" style={{height: `${height}px`}}>
            <div ref={inputEl}
                 onScroll={(e) => setScrollLeft(inputEl.current!.scrollLeft)}
                 onTouchEnd={(e) => {
                     if (scrollStarted) {
                         snap()
                     }
                     setScrollStarted(false)
                 }}
                 onTouchStart={(e) => {
                     let touch = e.touches.item(0)
                     setTranslateXStart(touch.clientX)
                     setTranslateYStart(touch.clientY)
                     setScrollStart(inputEl.current!.scrollLeft)
                 }}
                 onTouchMove={(e) => {
                     let touch = e.touches.item(0);
                     let xOffset = (touch.clientX - translateXStart)
                     let yOffset = (touch.clientY - translateYStart)
                     if (Math.abs(xOffset) > 2 * Math.abs(yOffset)) {
                         setScrollStarted(true)
                         inputEl!.current!.scroll({left: scrollStart - xOffset, top: 0})
                     }
                 }} className="Promo_carousel">
                {items}
            </div>
        </div>
        <AnimatedLine paused={scrollStarted} width={itemWidth} animate={true} onAnimationEnd={() => {
            snapToIndex(index+1);
        }} animationKey={`${index}`}/>
        <div className="Promo_carousel_info_title" style={{width: `${itemWidth}px`}}>
            {sectionData.features[(index-1)%3].name}
        </div>
    </div>

}